const sidebar = document.querySelector("#sidebar");
const openButton = document.querySelector(".sidebar_open_button");
const closeButton = document.querySelector(".sidebar-close");

let touchStartX = 0;
let touchEndX = 0;

function toggleSidebar() {
    const isOpen = sidebar.classList.toggle("open");
    document.body.classList.toggle("overflow-hidden", isOpen);
    document.body.classList.toggle("sideBar_menu_open", isOpen);
    openButton.setAttribute("aria-expanded", isOpen.toString());
    sidebar.setAttribute('aria-hidden', !isOpen);

    if (isOpen) {
        sidebar.removeAttribute('inert');
        setTimeout(() => trapFocus(sidebar, closeButton), 110);
    } else {
        sidebar.setAttribute('inert', '');
        setTimeout(closeAllAccordions, 200);
    }
    
}

function handleClickOutside(event) {
    if(sidebar.classList.contains("open") && !event.target.closest("#sidebar, .header-inner")) {
        closeSidebar();
    }
}

function closeSidebar() {
    sidebar.classList.remove("open");
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("sideBar_menu_open");
    openButton.setAttribute("aria-expanded", "false");
    openButton.focus();
    sidebar.setAttribute('aria-hidden', 'true');
    sidebar.setAttribute('inert', '');
    setTimeout(() => {
        closeAllAccordions();
    }, 200);
}

// Detect swipe left
function handleTouchStart(event) {
    touchStartX = event.touches[0].clientX;
}

function handleTouchEnd(event) {
    touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartX - touchEndX;

    // Close sidebar if swiped left (and swipe distance is more than 70px)
    if (swipeDistance > 70 && sidebar.classList.contains("open")) {
        closeSidebar();
    }
}

function initSidebarAccordion() {
    const accordions = document.querySelectorAll(".sidebar_accordion");
    
    accordions.forEach((accordion) => {
        const button = accordion.querySelector(".sidebar_accordion_title");
        const content = accordion.querySelector(".sidebar_accordion_content");
        
        const isOpen = accordion.classList.contains("open");
        button.setAttribute("aria-expanded", isOpen);
        content.setAttribute("aria-hidden", !isOpen);
        content.style.maxHeight = isOpen ? content.scrollHeight + "px" : "0";
        content.setAttribute("aria-hidden", !isOpen);
        
        button.addEventListener("click", () => toggleAccordion(accordion, button, content, accordions));
        button.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                button.click();
            }
        });
    });
}

function toggleAccordion(accordion, button, content, allAccordions) {
    // Close all other accordions first
    allAccordions.forEach((acc) => {
        if (acc !== accordion && acc.classList.contains("open")) {
            const otherButton = acc.querySelector(".sidebar_accordion_title");
            const otherContent = acc.querySelector(".sidebar_accordion_content");
            acc.classList.remove("open");
            otherButton.setAttribute("aria-expanded", "false");
            otherContent.setAttribute("aria-hidden", "true");
            otherContent.style.maxHeight = null;
        }
    });

    // Toggle the clicked one
    const isOpen = accordion.classList.toggle("open");
    button.setAttribute("aria-expanded", isOpen);
    content.setAttribute("aria-hidden", !isOpen);
    content.style.maxHeight = isOpen ? content.scrollHeight + "px" : null;
}


function closeAllAccordions() {
    const accordions = document.querySelectorAll(".sidebar_accordion");
    accordions.forEach((accordion) => {
        if (accordion.classList.contains("open")) {
            const button = accordion.querySelector(".sidebar_accordion_title");
            const content = accordion.querySelector(".sidebar_accordion_content");
            toggleAccordion(accordion, button, content);
        }
    });
}


function centerSidebarSearch() {
    const search = document.querySelector('.sidebar_search');
    if (!search) return;

    const marginTop = Math.max((window.innerHeight - search.offsetHeight) / 2 - search.getBoundingClientRect().top, 20);
    search.style.marginTop = `${marginTop}px`;
}


openButton.addEventListener("click", toggleSidebar);
closeButton.addEventListener("click", closeSidebar);
sidebar.addEventListener("touchstart", handleTouchStart);
sidebar.addEventListener("touchend", handleTouchEnd);
document.addEventListener("click", handleClickOutside);
document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && sidebar.classList.contains("open")) {
        closeSidebar();
    }
});
document.addEventListener("DOMContentLoaded", function () {
    initSidebarAccordion();
});
window.addEventListener('load', centerSidebarSearch);
// window.addEventListener('resize', centerSidebarSearch);